// extracted by mini-css-extract-plugin
export default {"simpleGridContainer":"_1PLNK"};